export const NavItems = [
    {
        isProfile: true,
    },
    {
        href: "#about",
        text: "About",
    },
    {
        href: "#projects",
        text: "Projects",
    },
    {
        href: "#services",
        text: "Services",
    },
    {
        href: "#contact",
        text: "Contact",
    },
    {
        hasSocialIcons: true
    },
    {
        hasCTA: true
    }

]